/******************************************************************************
   NAME:       CAYTHUMUC
   AUTHOR:     Duynh

   1. Load danh sách trạm ban đầu
   2. Mỗi lần Expand truy vấn với parameter là id -> có dữ liệu gán vào đúng vị trí -> xóa Loading...
   3. Mỗi lần chọn 1 thư mục, gửi lệnh tới service đang theo dõi sự kiện tại danhmucservice 

******************************************************************************/

import { Component, ViewChild, AfterViewInit, ViewEncapsulation, AfterContentInit, Output, EventEmitter, OnInit, NO_ERRORS_SCHEMA, Input, OnDestroy, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';

import { jqxDropDownButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownbutton';
import { jqxTreeComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxtree';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxComboBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcombobox';
import { DanhMucService, UserService } from '../../services/index';
import { Subscription } from 'rxjs/Subscription';

import { myJqxTreeItem } from '../../model/tree';
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-caythumuc',
  templateUrl: './caythumuc.component.html',
  styleUrls: ['./caythumuc.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: []

})


export class CayThuMucComponent implements AfterViewInit, AfterContentInit, OnDestroy, OnChanges {

  @Input() width: string = '100%';
  @Input() dropDownWidth: string = '450px';
  // 1 ghi vào SessionStorage, 0 không ghi
  @Input() writeToSessionStorage: number = 0;
  // 1 bắn sự kiện khi chọn, 0 bắn sự kiện
  @Input() changeNavEvent: number = 0;
  // tên cây cho mỗi module
  @Input() treeName: string = '';

  @Input() treeDisabled: boolean = false;

  // dùng để load combo: nếu kg tryền thì mặc định load theo user đăng nhập, truyền vào thì load theo id truyền
  @Input() danhmucid_loadcombo: number;
  // dùng để gán combo hiện tại: nếu tendanhmuc == '' thì chọn mặc định thằng đầu tiên trong tree, còn kg thì gán text = tendanhmuc_hientai
  @Input() danhmucid_hientai: number;
  @Input() tendanhmuc_hientai: string = '';

  // đếm số lượng điểm đo của từng danh mục hoặc không (mặc định không đếm)
  @Input() demsoluong: number = 0;

  @ViewChild('dropDownTram') dropDownTram: jqxDropDownButtonComponent;
  @ViewChild('treeDienLucTram') treeDienLucTram: jqxTreeComponent;
  //@ViewChild('cboCtydl') cboCtydl: jqxComboBoxComponent;

  private lst_danhmuc: any[];
  public dltong: string;


  //bien su kien reload
  subscription: Subscription;

  constructor(
    private DanhMucService: DanhMucService,
    private user: UserService
  ) {
    this.subscription = this.DanhMucService.reloadNav$.subscribe(
      item => {
        let user = this.user.getCurrentUser();
        if (this.danhmucid_loadcombo != undefined)
          this.getAllTram(this.danhmucid_loadcombo);
        else
          this.getAllTram(user.danhmucid);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.treeName != 'donvi' && this.treeName != 'bennhan') {
      this.ngAfterViewInit();
    }
  }
  public ngAfterViewInit(): void {

    let dropDownTramSettings: jqwidgets.DropDownButtonOptions =
    {
      width: '100%',
      height: '25',
      dropDownWidth: '400'
    }
    this.dropDownTram.setOptions(dropDownTramSettings);

    let dropDownContent = "<span style='vertical-align: sub;'><img width='20' height='20' src='assets/img/loading.gif'/>    Vui lòng đợi...</span>";
    this.dropDownTram.setContent(dropDownContent);

    let treeSettings: jqwidgets.TreeOptions =
    {
      width: '400',
      height: "370px"
    }
    this.treeDienLucTram.setOptions(treeSettings);


    let user = this.user.getCurrentUser();

    if (this.danhmucid_loadcombo != undefined)
      this.getAllTram(this.danhmucid_loadcombo);
    else
      this.getAllTram(user.danhmucid);

  }


  public ngAfterContentInit(): void {
    // let currentUser = this.user.getCurrentUser();
    // this.dltong = currentUser.tendanhmuc;
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }



  treeOnSelect(event: any): void {

    let item: any = this.treeDienLucTram.getSelectedItem();

    let item_detail = JSON.parse(item.value);
    let jqxitem = new myJqxTreeItem(item_detail.tendanhmuc, item_detail.danhmucid, item_detail.loaidanhmuc, this.treeName, item_detail.meterid, item_detail.tendanhmuc, item_detail.code);


    if (this.writeToSessionStorage == 1)
      sessionStorage.setItem(environment.SESSION_DANHMUC_NAME, JSON.stringify(jqxitem));
    if (this.changeNavEvent == 1)
      this.DanhMucService.changeNav(jqxitem);

    if (item_detail.loaidanhmuc > 3 && this.treeName == 'mainTree') {
      sessionStorage.removeItem(environment.DsKhachHang)
      let user = this.user.getCurrentUser();
      this.DanhMucService.getKhachHangByDanhMucID(item_detail.danhmucid, user.mataikhoan).subscribe(res => {
        let ret = JSON.parse(res);
        if (ret.data.length > 0) {
          sessionStorage.setItem(environment.DsKhachHang, JSON.stringify(ret.data));
        }
        else {
          sessionStorage.setItem(environment.DsKhachHang, "");
        }
        this.DanhMucService.loadCusDone();
      });
    }
    else {
      this.DanhMucService.loadCusDone();
    }
    let dropDownContent = `<div style="position: relative; margin-left: 3px; margin-top: 4px;">${item.label}</div>`;
    this.dropDownTram.close();
    this.dropDownTram.setContent(dropDownContent);
  }


  treeOnExpand(event: any): void {
    this.treeDisabled = true;
    let item: any = this.treeDienLucTram.getItem(event.args.element);
    let item_detail = JSON.parse(item.value);

    if (item.label == item_detail.tendanhmuc) {

      this.getSubNode(item_detail.danhmucid, item);

    }
    else {
      this.treeDisabled = false;
    }
  }



  public getAllTram(danhmucid: any) {
    debugger;
    let user = this.user.getCurrentUser();
    this.DanhMucService.getDanhmuc(danhmucid, "top", user.mataikhoan, this.demsoluong).subscribe(response => {
      this.dropDownTram.setContent("");
      let listTram: any = response;

      if (listTram.data.length > 0)
        listTram.data.forEach((item, index) => {

          item.value = JSON.stringify(item);
          let itemLoading: any = {
            danhmucid: "",
            danhmuccha: item.danhmucid,
            tendanhmuc: item.tendanhmuc,
            loaidanhmuc: ""
          };
          if (item.danhmucid != danhmucid)
            listTram.data.push(itemLoading);
          item.id = this.treeName + "_" + item.id;
        });
      else {
        let itemNone: any = {
          danhmucid: "",
          danhmuccha: null,
          tendanhmuc: "Tài khoản chưa được phân quyền, vui lòng liên hệ người quản trị",
          loaidanhmuc: ""
        };
        listTram.data.push(itemNone);
      }
      // prepare the data
      let source =
      {
        datatype: "json",
        datafields: [
          { name: 'danhmucid' },
          { name: 'danhmuccha' },
          { name: 'tendanhmuc' },
          { name: 'loaidanhmuc' },
          { name: 'value' },
          { name: 'id' }
        ],
        localdata: listTram.data
      };

      let dataAdapter = new jqx.dataAdapter(source);
      dataAdapter.dataBind();
      let records = dataAdapter.getRecordsHierarchy('danhmucid', 'danhmuccha', 'items', [{ name: 'id', map: 'id' }, { name: 'tendanhmuc', map: 'label' }, { name: 'value', map: 'value' }, { name: 'loaidanhmuc', map: 'name' }]);

      this.lst_danhmuc = listTram.data;
      this.treeDienLucTram.clear();
      this.treeDienLucTram.source(records);
      if (this.danhmucid_hientai == undefined) {
        if (this.danhmucid_hientai != -1) {

          let jqxitem = new myJqxTreeItem(records[0].label, records[0].danhmucid, records[0].loaidanhmuc, this.treeName, records[0].meterid, records[0].tendanhmuc, records[0].code);
          if (this.writeToSessionStorage == 1)
            sessionStorage.setItem(environment.SESSION_DANHMUC_NAME, JSON.stringify(jqxitem));
          if (this.changeNavEvent == 1)
            this.DanhMucService.changeNav(jqxitem);
        }
      }

      let tendanhmuc = records[0].label;
      if (this.tendanhmuc_hientai != "")
        tendanhmuc = this.tendanhmuc_hientai;
      if (this.danhmucid_hientai != -1) {
        let dropDownContent = `<div style="position: relative; margin-left: 3px; margin-top: 4px;">${tendanhmuc}</div>`;
        this.dropDownTram.setContent(dropDownContent);
      }
    });

  }

  public getSubNode(danhmucid: any, parent: any) {
    let user = this.user.getCurrentUser();
    this.DanhMucService.getDanhmuc(danhmucid, "child", user.mataikhoan, this.demsoluong).subscribe(response => {
      let listTram: any = response;
      if (listTram.data.length == 0) {
        this.treeDienLucTram.removeItem(parent.nextItem);
        this.treeDisabled = false;
        return;
      }

      listTram.data.forEach((item, index) => {
        item.value = JSON.stringify(item);
        let itemLoading: any = {
          danhmucid: "",
          danhmuccha: item.danhmucid,
          tendanhmuc: item.tendanhmuc,
          loaidanhmuc: item.loaidanhmuc
        };
        listTram.data.push(itemLoading);
        item.id = this.treeName + "_" + item.id;
      });
      // prepare the data
      let source =
      {
        datatype: "json",
        datafields: [
          { name: 'danhmucid' },
          { name: 'danhmuccha' },
          { name: 'tendanhmuc' },
          { name: 'loaidanhmuc' },
          { name: 'value' },
          { name: 'id' }
        ],
        localdata: listTram.data
      };

      let dataAdapter = new jqx.dataAdapter(source);
      dataAdapter.dataBind();
      let records = dataAdapter.getRecordsHierarchy('danhmucid', 'danhmuccha', 'items', [{ name: 'id', map: 'id' }, { name: 'tendanhmuc', map: 'label' }, { name: 'value', map: 'value' }, { name: 'loaidanhmuc', map: 'name' }]);

      this.treeDienLucTram.addTo(records, parent);

      this.treeDienLucTram.removeItem(parent.nextItem);

      this.treeDisabled = false;
    });

  }


}





// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/cay-thu-muc/caythumuc.component.ts